import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  redText: {
    color: 'red',
  },
  marginBottom: {
    marginBottom: '30px',
  },
}));

export default useStyles;
